module.exports = __webpack_public_path__ + "img/type-h1.4df15db9.svg";